export default "__VITE_ASSET__AV1myU4Z__"